import { render, staticRenderFns } from "./SmallInfo.vue?vue&type=template&id=7dd54bde&scoped=true&"
import script from "./SmallInfo.vue?vue&type=script&lang=ts&"
export * from "./SmallInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SmallInfo.vue?vue&type=style&index=0&id=7dd54bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd54bde",
  null
  
)

export default component.exports